export default __webpack_public_path__ + "static/Datenschutz-8a73d3cb9e1fec225cacc2d0a110cfeb.pdf";